/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import ipRegex from 'ip-regex';
import {
  FormTemplate,
  FormTemplateOption,
  FormTemplateSection,
} from 'data/template/template.types';
import { Network } from 'data/network/network.types';
import { DialedDigitExtractionServer } from 'data/dialedDigitExtractionServer/dialedDigitExtractionServer.types';

export type ListenersIpAddressPortsType = {
  [key:string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view' | 'copy',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'edit') {
    (clonedTemplate.main as FormTemplateSection).fields.PROCNAME.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.PARAMNAME.readOnly = true;
  } else if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

export function adaptTemplateOptions(
  template: FormTemplate | undefined,
  networkInterfaceList: Network[],
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  return clonedTemplate;
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}
